/**
 * Whether this build carries the DevDrawer and its API fault injection: dev and demo only. A
 * build-time constant, so production builds drop the drawer's code rather than hide it.
 */
export const DEV_TOOLS_ENABLED = import.meta.env.DEV || import.meta.env.MODE === 'demo'
